import script from "./SysLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./SysLayout.vue?vue&type=script&lang=ts&setup=true"

import "./SysLayout.vue?vue&type=style&index=0&id=e68632ee&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e68632ee"]])

export default __exports__